export function activityMediaFilenameExtension(url, isVideo) {
  try {
    const u = new URL(url);
    const m = u.pathname.match(/\.([a-z0-9]+)$/i);
    if (m) {
      const e = m[1].toLowerCase();
      return e === 'jpeg' ? 'jpg' : e;
    }
  } catch {
    /* ignore */
  }
  return isVideo ? 'mp4' : 'jpg';
}

// Fetches a remote file as a blob and triggers a save dialog.
// Falls back to opening a new tab if CORS blocks the fetch (e.g. Firebase Storage cross-origin).
export async function downloadRemoteFile(url, filename) {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error(String(res.status));
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch {
    try {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch {
      /* ignore */
    }
    return false;
  }
}
